import {
  clearRedeemError,
  getRedeemError,
  isRedeeming,
  redeemPin,
} from 'redux/modules/redeem';

import Pin from './Pin';
import { connect } from 'react-redux';
import { getHuggg } from 'redux/modules/huggg';

const mapStateToProps = (state, ownProps) => {
  return {
    huggg: getHuggg(state),
    redeemError: getRedeemError(state),
    isRedeeming: isRedeeming(state),
    ...ownProps,
  };
};

export default connect(mapStateToProps, { clearRedeemError, redeemPin })(Pin);
